export default {
    REDUCER_KEY: "INVOICE",
    ENTITY_NAME: "invoice",
    RESOURCE: "invoices",
};
